import {
  faFacebook,
  faPinterest,
  faXTwitter,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { faLink } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconButton from '@mui/material/IconButton';
import Image from 'components/Image';
import React from 'react';
import InstagramLogo from '../../images/brands/instagram.png';
import HiveLogo from '../../images/hive-logo.svg';
import { useState } from 'react';
import ExternalLinkModal from 'components/Post/ExternalLinkModal';
import { safeDecode } from 'helpers/safeHref';

const AuthorProfileBar = ({ profile }) => {
  const [externalLinkModal, setExternalLinkModal] = useState(undefined);

  const {
    website,
    twitter,
    facebook,
    instagram,
    youtube,
    pinterest,
    hive,
  } = profile;
  const social = [];
  if (website)
    social.push({
      name: 'Website',
      color: '',
      link: website,
      isNofollow: true,
      icon: (
        <>
          <FontAwesomeIcon style={{ width: 30, height: 30 }} icon={faLink} />
        </>
      ),
    });
  if (twitter)
    social.push({
      name: 'Twitter',
      link: `https://twitter.com/${twitter}`,
      icon: (
        <FontAwesomeIcon style={{ width: 30, height: 30 }} icon={faXTwitter} />
      ),
    });
  if (facebook)
    social.push({
      name: 'Facebook',
      color: '#1778F3',
      link: `https://facebook.com/${facebook}`,
      icon: (
        <FontAwesomeIcon
          style={{ width: 30, height: 30 }}
          icon={faFacebook}
          className="textPrimary"
        />
      ),
    });
  if (instagram)
    social.push({
      name: '',
      link: `https://instagram.com/${instagram}`,
      icon: (
        <>
          <Image src={InstagramLogo} alt="Instagram" height={30} width={30} />
        </>
      ),
    });
  if (youtube)
    social.push({
      name: 'Youtube',
      color: '#E73223',
      link: `https://youtube.com/channel/${youtube}`,
      icon: (
        <FontAwesomeIcon style={{ width: 30, height: 30 }} icon={faYoutube} />
      ),
    });
  if (pinterest)
    social.push({
      name: 'Pinterest',
      color: '#E50123',
      link: `https://pinterest.com/${pinterest}`,
      icon: (
        <FontAwesomeIcon style={{ width: 30, height: 30 }} icon={faPinterest} />
      ),
    });
  if (hive)
    social.push({
      name: 'Hive',
      color: '#E50123',
      isNofollow: true,
      link: `https://peakd.com/@${hive}`,
      icon: (
        <>
          <Image src={HiveLogo} alt="Hive" height={27} width={27} />
        </>
      ),
    });

  return (
    <>
      <div className="text-center pb-3 pl-3 pr-3">
        {social.map(s => {
          if (s.name === 'Website')
            return (
              <a
                key={s.name}
                title={s.name}
                onClick={() => setExternalLinkModal(safeDecode(s.link))}
                className="cpointer"
                style={s.color ? { color: s.color } : undefined}
              >
                <IconButton color="inherit" aria-label={s.name} size="large">
                  {s.icon}
                </IconButton>
              </a>
            );
          return (
            <a
              key={s.name}
              href={s.link}
              title={s.name}
              target="_blank"
              rel={
                s.isNofollow
                  ? 'noopener noreferrer nofollow'
                  : 'noopener noreferrer'
              }
              style={s.color ? { color: s.color } : undefined}
            >
              <IconButton color="inherit" aria-label={s.name} size="large">
                {s.icon}
              </IconButton>
            </a>
          );
        })}
        <ExternalLinkModal
          externalLinkModal={externalLinkModal}
          setExternalLinkModal={setExternalLinkModal}
        />
      </div>
    </>
  );
};

export default AuthorProfileBar;
